import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SelectUserComboBox from '../../../../components/SelectUserComboBox';
import cancelIcon from '../../../../assets/images/cancel-icon-gray.svg';
import dataModel from '../../../../models/DataModel';

import './ProjectContact.scss';
import Input from '../../../../components/Input';

export class ProjectContact extends React.Component {
  constructor(props) {
    ProjectContact.propTypes = {
      /** Location_User object representing the location contact. User data/object is on contact.user  */
      contact: PropTypes.object,
      /** List of users in the market of the location's company  */
      locationMarketUsers: PropTypes.array,
      /** Delete locaiton user */
      handleDeleteProjectContact: PropTypes.func,
      /** Save or update location user */
      handleSaveProjectContact: PropTypes.func,

    };
    super(props);
    this.state = {
      changed: false,
      showSaveButton: this.props.contact ? false : true,
      editedContact: Object.assign({}, props.contact),
    };

    this.handleContactChanged = this.handleContactChanged.bind(this);
    this.handleTitleChanged = this.handleTitleChanged.bind(this);
    this.handleClickX = this.handleClickX.bind(this);
    this.handleSaveProjectContact = this.handleSaveProjectContact.bind(this);
  }

  componentDidMount() {
    if (this.props.contact) {
      this.setState({ editedContact: this.props.contact });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.contact && !this.props.contact) {
      this.setState({ editedContact: {} });
    }
    else if (prevProps.contact != this.props.contact) {
      this.setState({ editedContact: Object.assign({}, this.props.contact) });
    }
  }

  handleContactChanged(type, optionSelected) {
    let { editedContact } = this.state;
    editedContact.user = optionSelected.user;
    this.setState({ changed: true, showSaveButton: true, editedContact });
  }

  handleTitleChanged(e) {
    let { editedContact } = this.state;
    editedContact.title = e.target.value;
    this.setState({ changed: true, showSaveButton: true, editedContact });
  }

  handleClickX() {
    if (!this.props.contact) {
      // the form is for a new contact, so the 'X' should clear it
      let { editedContact } = this.state;
      editedContact.title = null;
      editedContact.user = null;
      this.setState({ changed: false, editedContact });
    }
    else {
      // the form is for an exixting contact, so the 'X' should delete it
      this.props.dataModel.showGlobalModal('SYSTEM_POPUP', {
        message: 'Are you sure you want to remove '+this.state.editedContact.user.first_name + ' ' + this.state.editedContact.user.last_name + ' as '+ this.state.editedContact.title +'?',
        height: 220,
        width: 320,
        cancelButtonText: 'CANCEL',
        okButtonText: 'YES',
        handleOwnerOk: () => this.props.handleDeleteProjectContact(this.state.editedContact.id),
      });
    }
  }

  handleSaveProjectContact() {
    if (this.state.changed && this.state.editedContact.title && this.state.editedContact.user) {
      const locationUserId = this.props.contact ? this.props.contact.id : null;
      this.props.handleSaveProjectContact(locationUserId, this.state.editedContact);
      this.setState({ showSaveButton: false });
    }
  }

  render() {
    let saveButton; 
    if (this.state.showSaveButton) {
      let saveButtonClassName = 'project-contact__save';
      if (this.state.changed && this.state.editedContact.title && this.state.editedContact.user) {
        saveButtonClassName += ' project-contact__save--enabled';
      }
      saveButton = (
        <div className={saveButtonClassName}
          onClick={this.handleSaveProjectContact}>
          SAVE 
        </div>
      );
    }
    return (
      <div  className='project-contact'>
        <div className='project-contact__title'>
          <div className="project-label">TITLE</div>

          <Input className='project-contact-field' 
            value={this.state.editedContact.title || ''}
            onChange={this.handleTitleChanged}  //TODO
          />
        </div>
        <div className='project-contact__contact'>            
          <div className='project-label'>CONTACT</div>
          <SelectUserComboBox 
            users={this.props.contactMarketUsers}
            menuHeight={200}
            handleSelection={this.handleContactChanged}
            currentSelectedUser={this.state.editedContact.user}
            multiSelect={false}
            small={true}
            showSearchBar={true}
            searchHint={'Search Directory'}
            height={24}
            width={240}
            menuUp={true}
          />
        </div>
        {saveButton}
        <div className='location-contact__clear' onClick={ this.handleClickX }>
          <img src={cancelIcon} alt="remove contact"/>
        </div> 
      </div>
    );
  }
}

export default connect( 
  (state) => ({
    dataModel: dataModel,
  })
)(ProjectContact);



// WEBPACK FOOTER //
// ./src/containers/ProjectsContainer/ProjectCRUD/ProjectContact/index.js